export default __webpack_public_path__ + "static/media/logo.a291fe2a.svg";